<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="9.5" height="9.5" viewBox="0 0 9.5 9.5">
    <g id="add-small" transform="translate(0.75 0.75)">
      <line
        id="Line_5"
        data-name="Line 5"
        x1="8"
        transform="translate(0 4)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-width="1.5" />
      <line
        id="Line_6"
        data-name="Line 6"
        y1="8"
        transform="translate(4)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-width="1.5" />
    </g>
  </svg>
</template>
